export default ({ cobrand, eventType }) => {
  // schema para enviar al dar click en init, edit and accept voucher
  const event = `redeembenefit_step_${eventType}`;
  const dataLayerObj = {
    event,
    'funnel_name':'MYB',
    'sub_funnel_name':'upgrade voucher',
  };

  if (eventType !== 'accept') {
    return dataLayerObj;
  } else {
    return {
      'cobrand_upgrade': true,
      'share_brand': cobrand,
      ...dataLayerObj,
    };
  }
};